const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white py-12 px-6 text-center">
      <div className="max-w-4xl mx-auto">
        <p className="text-lg font-semibold mb-2">MAAC Audiovisuales</p>
        <p className="text-slate-400 text-sm">
          Soluciones técnicas de alta calidad para tus eventos.
        </p>
        <div className="mt-8 pt-8 border-t border-slate-800 text-slate-500 text-xs">
          © {new Date().getFullYear()} Todos los derechos reservados.
        </div>
      </div>
    </footer>
  );
};

export default Footer;